/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const NotificationCategory = {
    Account: 'Account',
    UploadsAndProcessing: 'UploadsAndProcessing',
    Moderation: 'Moderation',
    Takedowns: 'Takedowns',
    BountyActivity: 'BountyActivity',
    ActivityDigest: 'ActivityDigest',
    ProductNews: 'ProductNews',
    BountyMatches: 'BountyMatches'
};
export function NotificationCategoryFromJSON(json) {
    return NotificationCategoryFromJSONTyped(json, false);
}
export function NotificationCategoryFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function NotificationCategoryToJSON(value) {
    return value;
}
